import { render, staticRenderFns } from "./courseBalance.vue?vue&type=template&id=a40460a4&"
import script from "./courseBalance.vue?vue&type=script&lang=js&"
export * from "./courseBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports